
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iit-bazaar",
      function () {
        return require("private-next-pages/iit-bazaar.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iit-bazaar"])
      });
    }
  